import { defineStore } from 'pinia';
import { getActivitySetting } from '@/api/IceFire/activity';

const normalizeActivity = (data = {}) => ({
    id: data.id ?? null,
    enabled: Boolean(data.is_active ?? data.enabled),
    isActive: Boolean(data.is_active ?? data.enabled),
    startAt: data.activity_start_at ?? data.start_at ?? null,
    endAt: data.activity_end_at ?? data.end_at ?? null,
    scoreLogFreeze: Boolean(data.score_log_freeze),
    triggerEngineEnabled: Boolean(data.trigger_engine_enabled),
    qualifiedRankIds: data.qualified_rank_ids ?? [],
    lineTerminalRankIds: data.line_terminal_rank_ids ?? [],
    rankRulesMeta: data.rank_rules_meta ?? null
});

export const useActivityStore = defineStore('iceFireActivity', {
    state: () => ({
        id: null,
        enabled: false,
        isActive: false,
        startAt: null,
        endAt: null,
        scoreLogFreeze: false,
        triggerEngineEnabled: false,
        qualifiedRankIds: [],
        lineTerminalRankIds: [],
        rankRulesMeta: null,
        loaded: false,
        loading: false
    }),
    actions: {
        async fetch() {
            this.loading = true;
            try {
                const response = await getActivitySetting();
                if (response?.result === false) {
                    this.$patch({
                        loaded: true,
                        enabled: false,
                        isActive: false
                    });
                    return;
                }
                const data = response?.data ?? response;
                this.$patch({
                    ...normalizeActivity(data),
                    loaded: true
                });
            } catch {
                this.$patch({ loaded: true, enabled: false, isActive: false });
            } finally {
                this.loading = false;
            }
        }
    }
});
